<app-content-header
  backLabel="app_cancel"
  [stepsBack]="1"
  [headline]="'phonenumber_prepae_port_form_data' | i18next"
></app-content-header>

<div [formGroup]="form">
  <div class="d-flex justify-content-center mt-5">
    <div class="card card-nb card-mw-300">
      <div class="card-body">
        <div class="h3 red">{{ 'phonenumber_bill_check_company_name' | i18next }}</div>
        <div class="alert alert-warning" role="alert">
          {{ 'phonenumber_bill_check_company_name_warning' | i18next }}
        </div>
        <div class="mt-3 mb-3">
          <app-input-text
            [control]="form.get('companyName')"
            name="company_name"
            [autoFocus]="true"
            [placeholder]="companyName"
          ></app-input-text>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-5">
    <div class="card card-nb card-mw-300 w-100">
      <div class="card-body">
        <div class="h3 red">{{ 'phonenumber_prepare_port_form_custom_address_headline' | i18next }}</div>
        <div class="my-3">
          {{ 'phonenumber_prepare_port_form_custom_address_hint' | i18next }}
        </div>
        <div>
          <app-input-checkbox
            [control]="form.get('customAddress')"
            name="contact_invite"
            [text]="'phonenumber_prepare_port_form_show_custom_address_btn' | i18next"
          ></app-input-checkbox>
        </div>
        @if (form.get('customAddress').value) {
          <div class="mt-3">
            <div class="row">
              <div class="col-12 col-md-10">
                <app-input-text
                  [control]="form.get('street')"
                  name="street"
                  label="company_address_street_label"
                ></app-input-text>
              </div>
              <div class="col-12 col-md-2">
                <app-input-text
                  [control]="form.get('house_number')"
                  name="house_number"
                  label="company_house_number_label"
                ></app-input-text>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6">
                <app-input-text
                  [control]="form.get('zip')"
                  name="zip"
                  label="company_address_zip_label"
                ></app-input-text>
              </div>
              <div class="col-12 col-md-6">
                <app-input-text
                  [control]="form.get('city')"
                  name="city"
                  label="company_address_city_label"
                ></app-input-text>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-end mt-2">
  <button class="btn btn-outline-primary" (click)="onNext()" [disabled]="!isValid()">{{ 'app_next' | i18next}}</button>
</div>
